<template>
  <section>
    <!-- 起点 -->
    <section class="start posire">
      <article class="leftLine posiab">
        <img class="logo posiab" src="~images/carStart.png" />
        <img class="next posire" src="~images/next.png" />
      </article>
      <h2 class="title">
        {{transportPointName.startPointName || '起点城市'}}
        <span
          class="addBtn primary cur"
          @click="$emit('add')"
        >
          增加经停点
        </span>
      </h2>
      <section>
        <slot name="start" />
      </section>
    </section>
    <!-- 起点 end -->
    <!-- 中间 -->
    <section class="middle posire"
      v-for="(item, index) in middleData"
      :key="item.id"
    >
      <article class="leftLine posiab">
        <img class="logo posiab" src="~images/carMiddle.png" />
        <img class="next posire" src="~images/next.png" />
      </article>
      <h2 class="title">
        {{transportPointName.transPointName || '经停城市'}}{{index + 1}}
        <span
          class="addBtn primary cur"
          @click="$emit('add', index)"
        >增加经停点</span>
        <span
          class="addBtn primary cur"
          @click="$emit('del', index)"
        >删除经停点</span>
      </h2>
      <section>
        <slot :name="'middle' + index" />
      </section>
    </section>
    <!-- 中间 end -->
    <!-- 终点 -->
    <section class="end posire">
      <article class="leftLine posiab noBg">
        <img class="logo posiab" src="~images/carEnd.png" />
      </article>
      <h2 class="title">
        {{transportPointName.endPointName || '终点城市'}}
      </h2>
      <section>
        <slot name="end" />
      </section>
    </section>
    <!-- 终点 end -->
  </section>
</template>

<script>
export default {
  props: {
    middleData: {
      type: Array,
      default: () => ([]),
    },
    transportPointName: {
      type: Object,
      default: () => ({}),
    },
  },
  data () {
    return {
    };
  },
  methods: {

  },
};
</script>

<style scoped lang="scss">
.leftLine{
  width: 4px;
  height: 100%;
  top: 0;
  left: 12px;
  background: #e6f7ff;
  padding-bottom: 18px;
  .logo{
    width: 32px;
    height: 32px;
    top: 0;
    left: -14px;
  }
  .next{
    width: 16px;
    height: 16px;
    top: 60%;
    left: -6px;
    transform: translate(0, -50%);
  }
}
.noBg{
  background: none;
}
.title{
  height: 32px;
  line-height: 32px;
  border-radius: 100px 0 0 100px;
  background: #fafafa;
  padding-left: 32px;
  margin-left: 36px;
  margin-bottom: 16px;
  .addBtn{
    margin-left: 32px;
  }
}
</style>
